module.exports = __webpack_public_path__ + "img/kong-dingdan.2ad8daa3.png";